import { Col, Row } from 'react-bootstrap';

import AdminLayout from './layout/AdminLayout';
import UcrtAuditList from '../components/admin/ucrt/UcrtAuditList';
const UcrtAuditTrail = () => {
  
    return (
        <AdminLayout>
            <Row>
                <Col className="container mb-4">
                    <UcrtAuditList />
                </Col>
            </Row>
        </AdminLayout>
    )
}

export default UcrtAuditTrail;